export const UPDATE_WRITING_CHAPTER = 'UPDATE_WRITING_CHAPTER';
export const updateWritingChapter = q => ({
  type: UPDATE_WRITING_CHAPTER,
  payload: q
});
